<script>
  import TextInput from "../../components/Form/TextInput.svelte";
  import { translator } from "../../store";
  let selectedMonth = new Date().getMonth() + 1;
  let selectedYear = new Date().getFullYear();

  function generateLink(reportRoute, selectedMonth, selectedYear) {
    return `https://ci.evinidodola.com/reports/${reportRoute}?month=${selectedMonth < 10 ? '0' + selectedMonth : selectedMonth}&year=${selectedYear}&token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9`;
  }
</script>

<div style="display: flex; align-items: center">
  <div style="flex-grow: 1; padding: 0px 16px">
    <TextInput
      label={translator("Ay")}
      type="number"
      step="1"
      min="1"
      onChange={(value) => {
        selectedMonth = value;
      }}
      value={selectedMonth}
      required
    />
  </div>
  <div style="flex-grow: 1; padding: 0px 16px">
    <TextInput
      label={translator("Yıl")}
      type="number"
      step="1"
      min="1"
      onChange={(value) => {
        selectedYear = value;
      }}
      value={selectedYear}
      required
    />
  </div>
</div>
{#if selectedMonth && selectedYear}
<hr />
<div style="padding-top: 16px">
  <div style="display:flex; align-items:center">
    <h3><a href={generateLink('monthly-overview-report', selectedMonth, selectedYear)} target="_blank" rel="noreferrer">Aylık Özet Rapor</a></h3>
  </div>
  <div style="display:flex; align-items:center">
    <h3><a href={generateLink('monthly-invoice-report', selectedMonth, selectedYear)} target="_blank" rel="noreferrer">Aylık Fatura Dökümü Tablosu</a></h3>
  </div>
</div>
{:else}
  <div
    class="h-100 w-100 text-center pt-5"
    style="background-color: rgba(250, 250, 250, 0.3); z-index: 2; border-radius: 30px"
  >
    <h1>{translator("Rapor oluşturmak için ay ve yıl seçiniz")}</h1>
  </div>
{/if}
